import { useState } from 'react';
import {
  BatchCreateBalancesPaymentRequestsRequest_ExistingBalanceRequestOption,
  BatchCreateBalancesPaymentRequestsRequest_NewBalanceCreateRequestOption,
  BatchCreateBalancesPaymentRequestsRequest_UpdatedBalanceRequestOption,
} from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { theme } from '@frontend/theme';
import { Accordion, DropdownField, FieldProps, Heading, Text } from '@frontend/design-system';
import { fields } from '../types';

type BalancesAccordianProps = {
  title: string;
  subtitle: string;
  body: string;
  options: {
    label: string;
    value:
      | BatchCreateBalancesPaymentRequestsRequest_NewBalanceCreateRequestOption
      | BatchCreateBalancesPaymentRequestsRequest_UpdatedBalanceRequestOption
      | BatchCreateBalancesPaymentRequestsRequest_ExistingBalanceRequestOption;
  }[];
  fieldProps: FieldProps<fields, keyof fields>;
  count?: number;
};
export const BalancesAccordian = ({ title, subtitle, body, options, fieldProps, count }: BalancesAccordianProps) => {
  const [isOpened, setIsOpened] = useState(false);
  return (
    <div
      css={{
        border: `1px solid ${theme.colors.neutral20}`,
        borderRadius: theme.borderRadius.medium,
        button: {
          backgroundColor: isOpened ? theme.colors.neutral5 : 'transparent',
        },
      }}
    >
      <Accordion onChange={(val) => setIsOpened(!!val)} shouldRenderBody variant='blank'>
        <Accordion.Item value={title} css={{ borderRadius: theme.borderRadius.medium }}>
          <Accordion.Header>
            <div>
              <div css={{ display: 'flex', gap: theme.spacing(1), alignItems: 'center' }}>
                <Heading level={3}>{title}</Heading>
                <Text color='subdued' size='small'>
                  {count}
                </Text>
              </div>
              <Text>{subtitle}</Text>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(1),
              }}
            >
              {body}
              <DropdownField {...fieldProps} label=''>
                {options.map(({ label, value }) => (
                  <DropdownField.Option key={value} value={value}>
                    <Text color='subdued'>{label}</Text>
                  </DropdownField.Option>
                ))}
              </DropdownField>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
